<template>

  <div id='register'>

    <h1>Registrera dig här</h1>
    <input type="text" v-model="name" placeholder="Ditt namn" /><br>
    <input type="text" v-model="email" placeholder="Din e-post" /><br>
    <input type="text" v-model="regId" style='width:50%;' placeholder="Ditt regnummer" /><br>
    
    <br>

   
    <input type="checkbox" v-model="condition"/> <b> Jag har läst, förstår och godkänner användarvillkoren för tjänsten Min Trängselskatt.<br/>Användarvillkoren finns längst ned på sidan.</b><br><br>
    <button v-on:click="register">REGISTRERA MIG</button>
    <div class='messageWrapper'>
     <transition name="fade">
    <div class="message" v-if="result.length > 0" @click="result = ''" :style="error ? {'background': 'red'} : {'background': 'green'}"> {{ result }} </div>
    </transition>
    </div>

    <div id='price'>
        <img alt="20kr per år" src="../assets/pricetag.png">
        <h3>Tjänsten är gratis i tre månader. Efter tre månader får du ett mail och du kan själv välja om du vill förlänga tjänsten ett år genom att betala introduktionspriset på 20&nbsp;kronor med Swish.<br/>Annars avslutas tjänsten helt automatiskt.</h3>
        <div style="clear:both;"></div>
    </div>

  </div>
</template>

<script>

import validator from './mixins/email'

const axios = require('axios');

export default {
  name: 'Register',
  props: {
  },
    mixins: [validator],

data: function () {
  return {
    name: "",
    email: "",
    regId: "",
    condition: false,
    result: "",
    show: false,
    error: false
  }
},
    methods: {
        register: async function () {
   
            if (!this.condition){
                this.error = true;
                this.result = "Du måste godkänna våra användarvillkor";
                return;
            }

            if (this.name.length < 3){
                this.error = true;
                this.result = "Ange ett namn på minst tre tecken";
                return;
            }

            if (this.email.length < 7){
                this.error = true;
                this.result = "Ogiltig e-post";
                return;
            }

            axios.post(this.$hostname + '/register/', {
            
                        name:this.name,
                        email:this.email,
                        regId:this.regId,
                        condition:this.condition
                    
            })
            .then(response => {

                if (response.data.status == "OK"){
                    
                    this.error = false;
                    this.name = "";
                    this.email = "";
                    this.regId = "";
                    this.condition = false;
                    this.result = response.data.message;
                    
                }else if (response.data.status == "FAIL"){
                    this.result = response.data.message;
                    this.error = true;
                }else{
                    alert(response.data);
                    this.result = "Kunde inte spara UI";
                    this.error = true;
                }

                
            })
            .catch(error =>  {
                alert("FAIL: " + error);
                this.result = "FAIL"
                
            });   
        }
     }
     
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

div#register{
    padding:20px;
    color:white;
}

div#register input{
    margin-bottom:20px;
    
}

div#register input[type='text']{
  font-size:1.2em;
  width: calc(100% - 20px);
  border-radius: 10px;
   border:0px solid transparent;
    padding:10px;
  
}

div#register button{
    font-size:1.2em;
    border-radius: 10px;
    background-color:#2196f3;
    color:white;
    padding:10px;
    padding-left:20px;
    padding-right:20px;
    border:0px solid transparent;
  
}



#price{
    background-color: rgb(107, 106, 105);
    padding: 10px;
    margin-top:20px;
    color:white;
    border-radius: 10px;

}

#price img{
    padding-left:20px;
    float:right;
    width:100px;
    height:auto;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>